// based on rc-notification 3.3.1
import Notification from './Notification';
export default Notification;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ant-design-vue@1.7.8@ant-design-vue/es/vc-notification/index.js
// module id = null
// module chunks = 